import Vue from 'vue';
import RadioButton from 'primevue/radiobutton';

Vue.component('RadioButton', RadioButton);
